module.exports = __webpack_public_path__ + "img/Jump Casting106.e8dbbc79.jpg";